<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Orders</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary" class="ion-text-wrap">
        {{orders.length}} orders defined.
    </ion-list-header>

    <ion-list class="ion-padding">
        @for (order of orders; track $index) {
  <ion-item-sliding>
            <ion-item detail="true" (click)="onOrderClick(order.uid)">
                <ion-label>
                    <span class="line1">Order Number: {{order.header.orderId}}</span><br />
                    <span class="line2">Purchased On: {{getPurchasedDate(order)}}</span><br />

                    <!-- <span class="line2">Purchased On: {{order.header.createdDateFormatted}}</span><br /> -->
                    <span class="line2">Amount: {{order.header.totalFormatted}}</span><br />
                    <span class="line2">{{order.header.description}}</span>
                </ion-label>
            </ion-item>
        </ion-item-sliding>
}
    </ion-list>
</ion-content>